export const normalizePhoneNumber = (contactNo: string): string => {
  if (!contactNo) {
    return contactNo;
  }
  let normalized = contactNo.trim();
  if (normalized.startsWith("63")) {
    normalized = normalized.slice(2);
  }
  if (normalized.startsWith("0")) {
    normalized = normalized.slice(1);
  }

  return normalized;
};
